import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  box: {
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    fontWeight: 'inherit',
    fontSize: 'inherit'
  },
  label: {
    fontSize: '0.8rem',
    color: '#747474'
  },
  text: {
    fontWeight: 'inherit',
    fontSize: 'inherit'
  }
});

interface StringProps {
  input: {
    value: string;
  };
  options?: any;
  label?: string;
  bolded?: boolean;
  startAdornment?: string;
  endAdornment?: string;
}

const String = ({
  input,
  options,
  label,
  bolded,
  startAdornment = '',
  endAdornment = ''
}: StringProps) => {
  const { value } = input;
  const classes = useStyles();
  if (options) {
    const optionChoosen = options.find(
      (option: any) => Number(option.value) === Number(value)
    );
    return (
      <p className={classes.box}>
        {label && <span className={classes.label}>{label}</span>}
        <span style={{ fontWeight: bolded ? 500 : 400 }}>
          {optionChoosen && optionChoosen.name}
        </span>
      </p>
    );
  }
  return (
    <p className={classes.box}>
      {label && <span className={classes.label}>{label}</span>}
      <span className={classes.text}>
        {/* {startAdornment ? startAdornment + value : value} */}
        {`${startAdornment}${value}${endAdornment}`}
      </span>
    </p>
  );
};

export default String;
